define([
    'text!WebCommon/menu/menu.html',
    'vue',
    'jquery',
    'WebCommon/utils',
    'WebCommon/menu/talk-btn',
    'web/common/menu/share-btn',

    'css!WebCommon/menu/menu.css'
], function(
    tpl,
    Vue,
    $,
    Utils,
    TalkBtn,
    ShareBtn
){
    var $overlay = $('<div/>').appendTo('body');

    return new Vue({
        el: $overlay[0],
        template: tpl,
        components: {
            TalkBtn: TalkBtn,
            ShareBtn: ShareBtn
        },
        data: {
            isBottomBtnShow: true,
            isTopBtnShow: false,
            shareBtnData: null
        },
        methods: {
            initTopBtn: function(){
                var $window = $(window);
                var height = $window.height();
                var _this = this;

                $window.on('scroll resize', function(){
                    var scrollTop = $window.scrollTop();
                    _this.isTopBtnShow = scrollTop > height;
                });
            },
            scrollToTop: function(){
                Utils.scrollTo(0);
            },
            setShareBtnData: function(obj){
                this.shareBtnData = obj;
            },
            scrollToBottom: function () {
                var $windows = $(window);
                var heights = $windows.height();
                var bodyHeight = document.body.scrollHeight;
                var scrollHeight = bodyHeight - heights;
                Utils.scrollTo(scrollHeight)
            }
        },
        mounted: function(){
            this.initTopBtn();
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ../common/menu/menu.js
// module id = 71
// module chunks = 0 1 2 3 4 5 6 7 8